module.exports = __webpack_public_path__ + "static/img/value_3.b667322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/value_3.png
// module id = P53M
// module chunks = 1